import { ObservableArray, View } from "binder"
import { PartTypeSelectorViewModel, type } from "./partTypeSelector-viewModel"

export class PartTypeSelectorView extends View<PartTypeSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-70B39EA2-9BE0-494C-A8DE-FA6EAF1A3558"
    }
    loadHtml(): string {
        let element = require('./partTypeSelector.html').default;
        let style = require('./partTypeSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set types(v: ObservableArray<type>) { this._types = v; } public get types(): ObservableArray<type> { return this._types;} private _types: ObservableArray<type>;
    public set selectedType(v: type) { this._selectedType = v; } public get selectedType(): type { return this._selectedType;} private _selectedType: type;
    
    confirm(){
        this.dataContext.confirm();
    }
    back(){
        this.dataContext.back();
    }
}
